import { Coordinate } from "ol/coordinate";
import React, { createContext, useContext, useState } from "react";

interface incidentsSidebar{
    sensorId: string | null,
      coordinates: Coordinate | null,
      adm4_en: string | null,
      bwater_level: string | null,
      end_time: string | null,
      hwater_level: string | null,
      img_url: string | null,
      imp_communication: string | null,
      imp_electricity: string | null,
      imp_house: string | null,
      imp_human: string | null,
      imp_response: string | null,
      imp_roadblock: string | null,
      imp_roaddamage: string | null,
      imp_water: string | null,
      impdes_communication: string | null,
      impdes_electricity: string | null,
      impdes_house: string | null,
      impdes_human: string | null,
      impdes_roadblock: string | null,
      impdes_roaddamage: string | null,
      impdes_water: string | null,
      issued_time: string | null,
      occurance_date: string | null,
      observed_date: string | null,
      tp_number: string | null,
      w_desc: string | null,
      w_name: string | null,
      w_type: string | null
  }

// Define the context type
type HzContextType = {
  HzOpenSidebarMap: Map<string, incidentsSidebar>;
  setHzOpenSidebarMap: (type: string, ewsopenMap: incidentsSidebar) => void;
  removeFromHzOpenSidebarMap: (active_pcode: string) => void;
  clearHzOpenSidebarMap: () => void;
  clickedHzString: string | null;
  setClickedHzString: (value: string) => void;
};

// Create the context
const HzContext = createContext<HzContextType | undefined>(undefined);

// Define the provider component
export const HzProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Initialize HzOpenSidebarMap in state
  const [HzOpenSidebarMap, setHzOpenSidebarMapState] = useState(new Map<string, incidentsSidebar>());
  const [clickedHzString, setClickedHzString] = useState<string | null>(null);

  // Function to add or update an entry in HzOpenSidebarMap
  const setHzOpenSidebarMap = (type: string, HzopenMap: incidentsSidebar) => {
    setHzOpenSidebarMapState((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(type, HzopenMap);
      return newMap;
    });
  };

  // Function to remove an entry by active_pcode
  const removeFromHzOpenSidebarMap = (active_pcode: string) => {
  
    setHzOpenSidebarMapState((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.delete(active_pcode);
      return newMap;
    });
  };
    // Function to clear the map
    const clearHzOpenSidebarMap = () => {
        setHzOpenSidebarMapState(new Map());
      };

  // Provide the state and the updater functions
  return (
    <HzContext.Provider value={{ HzOpenSidebarMap, setHzOpenSidebarMap, removeFromHzOpenSidebarMap,clearHzOpenSidebarMap, clickedHzString, setClickedHzString }}>
      {children}
    </HzContext.Provider>
  );
};

// Custom hook for using HzContext
export const useHzContext = () => {
  const context = useContext(HzContext);
  if (!context) {
    throw new Error("useHzContext must be used within an HzProvider");
  }
  return context;
};
